
<section class="d-flex align-items-center justify-content-center pt-4">

<div class="coming-soon-container">
  <div class="title">COMING SOON</div>


  <div class="logo-section">
      <div class="wifi-section">
    <img
      src="../assets/img/ruralx-wifi.webp"
      alt="RuralX Wifi"
      class="wifi-image"
    />
  </div>

    <img
      src="../assets/img/ruralx-cart.webp"
      alt="RuralX Logo"
      class="logo-image"
    />
  </div>

  <p class="subtitle">
    Service is not yet available<br />
    in your pincode
  </p>
</div>
</section>